import React, { useState, useEffect } from "react";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import { http } from "../../helper";
import { BaseUrl } from "../../common/config";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
const AddSectorPromoOffers = () => {
    const { t } = useTranslation();
    const [cartAmountFrom, setCartAmountFrom] = useState(0);
    const [cartAmountTo, setCartAmountTo] = useState(0);
    const [cartAmountTarget, setCartAmountTarget] = useState(0);
    const [freeProductsCount, setFreeProductsCount] = useState(1);
    const [errormsg, setErrormsg] = useState({});
    const [freeloading, setfreeLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [freeproducts, setfreeProducts] = useState([]);
    const [alertPopup, setAlertPopup] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertMessage1, setAlertMessage1] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = useState(1);
    const [status, setStatus] = useState("active");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [selectedFreeCategories, setSelectedFreeCategories] = useState([]);
    const [checkedval, setCheckedval] = useState([]);
    const [checkedfreeval, setCheckedfreeval] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const [checkedBandState, setCheckedBandState] = useState([]);
    const [checkedBand, setCheckedBand] = useState([]);
    const [checkedfreeState, setCheckedfreeState] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [errmessage, setErrMessage] = useState({});
    const [priceBandIds, setPriceBandIds] = useState([]);
    const [alertSector, setAlertSector] = useState("");

    const [isSectorLoading, setIsSectorLoading] = useState(false);
    const [sectorOptions, setSectorOptions] = useState([]);
    const [beforeTooltipMessage, setBeforeTooltipMessage] = useState("");
    const [afterTooltipMessage, setAfterTooltipMessage] = useState("");
    const [flexTitle, setFlexTitle] = useState("");
    const [isSuccessPopup, setIsSuccessPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    if (!sessionStorage.getItem("isLoggedIn")) {
        window.location.href = "/";
    }
    if (
        JSON.parse(sessionStorage.getItem("authData")) != "" &&
        !JSON.parse(
            sessionStorage.getItem("authData")
        ).adminRole.permissions.includes("manage_promooffers")
    ) {
        window.location.href = "/unauthorized";
    }

    function cancelbtn(e) {
        e.preventDefault();
        window.location.href = "/promooffers?tab=sector";
        return false;
    }
    useEffect(() => {
        setCheckedState(new Array(products.length).fill(false));

        //setLoading(true);
        setCheckedval([]);
    }, [products]);

    useEffect(() => {
        let arry = [];
        {
            arry = new Array(freeproducts.length).fill(false);
        }
        setCheckedfreeState(arry);

        setfreeLoading(true);
        setCheckedfreeval([]);
    }, [freeproducts]);

    useEffect(() => {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
            loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }

        var priceCode = "PL1";
        let URL = `${BaseUrl}admin/productprice/${priceCode}`;
        http
            .get(URL)
            .then((response) => {
                let responseData = response.data.data;
                setProducts(responseData);
                setfreeProducts(responseData);
            })
            .catch((err) => {
                console.log(err);
                setLoading(true);
            });


        let URL1 = `${BaseUrl}admin/getpricebandids`;
        http
            .get(URL1)
            .then((response) => {
                let responseData = response?.data?.data;
                // Filter out duplicate price band IDs
                // Convert to a Set to remove duplicates  
                // and then convert back to an array
                const uniquePriceBandIds = responseData.filter((item, index, self) =>
                    index === self.findIndex((t) => t.accountPriceListId === item.accountPriceListId)
                );
                setPriceBandIds(uniquePriceBandIds);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(true);
            });
    }, []);

    // Map of category names to category IDs
    const categoryMap = {
        pizza: ["1"],
        pasta: ["10", "13"],
        burrito: ["11", "12"],
        desserts: ["14"]
    };

    const handleOnChange1 = (position, e) => {
        const updatedfreeCheckedState = checkedfreeState.map((item, index) => {
            return index === position ? !item : item;
        });

        var updatedList = [...checkedfreeval];

        if (e.target.checked) {
            updatedList = [...checkedfreeval, e.target.value];
        } else {
            updatedList.splice(checkedfreeval.indexOf(e.target.value), 1);
        }
        setCheckedfreeval(updatedList);
        setErrormsg((prev) => ({
            ...prev,
            checkedfreevalErr: updatedList.length > 0 ? "" : "This field is required",
        }));
        setCheckedfreeState(updatedfreeCheckedState);
    };

    const handleOnChangeBand = (position, e) => {


        const updatedCheckedState = checkedBandState.map((item, index) => {
            return index === position ? !item : item;
        });

        var updatedList = [...checkedBand];

        if (e.target.checked) {
            updatedList = [...checkedBand, e.target.value];
        } else {
            updatedList.splice(checkedBand.indexOf(e.target.value), 1);
        }
        setCheckedBand(updatedList);
        setCheckedBandState(updatedCheckedState);

    };

    const freeCountChange = (e) => {
        setFreeProductsCount(e.target.value);
        setErrormsg((prev) => ({ ...prev, freeProductsCountErr: "" }));
    };


    const messageHandleChange = (e) => {
        setAlertMessage(e.target.value);
        const value = e.target.value || "";
        setErrormsg((prev) => ({
            ...prev,
            messageErr: value.trim() ? "" : prev.messageErr,
        }));
    };

    const message1HandleChange = (e) => {
        setAlertMessage1(e.target.value);
        const value = e.target.value || "";
        setErrormsg((prev) => ({
            ...prev,
            message1Err: value.trim() ? "" : prev.message1Err,
        }));
    };

    // const eventFromAmountHandleChange = (e) => {
    //     const value = e.target.value || "";
    //     setCartAmountFrom(value);

    //     setErrormsg((prev) => ({
    //         ...prev,
    //         cartAmountFromErr: value.trim() ? "" : prev.cartAmountFromErr,
    //     }));
    // };

    // const eventToAmountHandleChange = (e) => {
    //     const value = e.target.value || "";
    //     setCartAmountTo(value);

    //     setErrormsg((prev) => ({
    //         ...prev,
    //         cartAmountToErr: value.trim() ? "" : prev.cartAmountToErr,
    //     }));
    // };

    const targetAmountHandleChange = (e) => {
        const value = e.target.value || "";
        setCartAmountTarget(value);

        setErrormsg((prev) => ({
            ...prev,
            cartAmountTargetErr: value.trim() ? "" : prev.cartAmountTargetErr,
        }));
    };

    const eventSectorHandleChange = (e) => {
        const value = e.target.value || "";
        setAlertSector(value);

        setErrormsg((prev) => ({
            ...prev,
            sectorErr: value.trim() ? "" : prev.sectorErr,
        }));
    };
    const beforeTooltipHandleChange = (e) => {
        const value = e.target.value;
        setBeforeTooltipMessage(value);
        setErrormsg((prev) => ({
            ...prev,
            beforeTooltipErr: value.trim() ? "" : prev.beforeTooltipErr,
        }));
    };
    const afterTooltipHandleChange = (e) => {
        const value = e.target.value;
        setAfterTooltipMessage(value);
        setErrormsg((prev) => ({
            ...prev,
            afterTooltipErr: value.trim() ? "" : prev.afterTooltipErr,
        }));
    };
    const flexTitleHandleChange = (e) => {
        const value = e.target.value;
        setFlexTitle(value);
        setErrormsg((prev) => ({
            ...prev,
            flexTitleErr: value.trim() ? "" : prev.flexTitleErr,
        }));
    };
    const formvalidation = () => {
        let newErrors = {};
        let isValid = true;

       
        if (!alertMessage) {
            newErrors.messageErr = "This field is required";
            isValid = false;
        }
        if (!alertSector) {
            newErrors.sectorErr = "This field is required";
            isValid = false;
        }
        if (!alertMessage1) {
            newErrors.message1Err = "This field is required";
            isValid = false;
        }
        if (!cartAmountTarget) {
            newErrors.cartAmountTargetErr = "This field is required";
            isValid = false;
        }

        if (!checkedfreeval.length) {
            newErrors.checkedfreevalErr = "This field is required";
            isValid = false;
        }
        if (!beforeTooltipMessage) {
            newErrors.beforeTooltipErr = "This field is required";
            isValid = false;
        }
        if (!afterTooltipMessage) {
            newErrors.afterTooltipErr = "This field is required";
            isValid = false;
        }
        if (!flexTitle) {
            newErrors.flexTitleErr = "This field is required";
            isValid = false;
        }
        setErrormsg(newErrors);
        return isValid;
    };


    const submitButton = (e) => {
        e.preventDefault();
        const selectedSector = sectorOptions.find(
            (s) => String(s.value) === String(alertSector)
        );
        const isValid = formvalidation();
         // VALIDATION TO CHECK THE SLECTED PRODUCTS
        if (checkedfreeval.length > freeProductsCount) {
            setIsSuccessPopup(false);
            setAlertPopup(true);
            setPopupMessage(
                `You selected ${checkedfreeval.length} products but allowed only ${freeProductsCount}. Please adjust your selection.`
            );
            return;
        }
        if (isValid) {
            let payload = {
                sectorName: selectedSector?.name || "",
                //cartAmountFrom: cartAmountFrom,
                //cartAmountTo: cartAmountTo,
                cartAmountTarget: cartAmountTarget,
                FromDate: fromDate,
                ToDate: toDate,
                sortOrder: sortOrder,
                freeProductToAdd: checkedfreeval.toString(),
                freeProductQtyToAdd: freeProductsCount,
                Status: status,
                createdBy: JSON.parse(sessionStorage.getItem("authData")).adminName,
                message: alertMessage,
                message1: alertMessage1,
                beforeTooltipMessage: beforeTooltipMessage,
                afterTooltipMessage: afterTooltipMessage,
                flexTitle: flexTitle,
                PriceBandTobeExcluded: checkedBand.toString(),
            };
            var loginDetails = {};
            if (sessionStorage.getItem("authData")) {
                loginDetails = JSON.parse(sessionStorage.getItem("authData"));
            }

            let URL = BaseUrl + "admin/addsectorpromooffers";
            http
                .post(URL, payload)
                .then((response) => {
                    if (response.data.success === true) {
                        const sectorName =
                            sectorOptions.find(
                                s => String(s.value) === String(alertSector)
                            )?.name || alertSector;
                        setIsSuccessPopup(true);
                        setAlertPopup(true);
                        setPopupMessage(`Sector Based (${sectorName}) Promo Offer added successfully.`);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleFreeCategoryChange = (e) => {
        const { name, checked } = e.target;

        setSelectedFreeCategories((prevSelectedFreeCategories) => {
            if (checked) {
                // Add the category if it's checked
                return [...prevSelectedFreeCategories, name];
            } else {
                // Remove the category if it's unchecked
                return prevSelectedFreeCategories.filter((cat) => cat !== name);
            }
        });
    };

    const handleclick = () => {
        setExpanded(!expanded);
        setfreeLoading(false);
    };

    const getFilteredFreeProducts = () => {
        const selectedFreeCategoryIds = selectedFreeCategories
            .map((category) => categoryMap[category])
            .flat(); // Flatten the array to merge all IDs into one array
        // Filter products based on the selected category IDs
        return freeproducts.filter((prd) =>
            selectedFreeCategoryIds.includes(prd.categoryId)
        );
    };

    const filteredFreeProducts = getFilteredFreeProducts();

    const fetchSectors = async () => {
        try {
            setIsSectorLoading(true);
            // 1. Get all sectors
            const sectorRes = await http.get(`${BaseUrl}admin/product/masterentries/sectors`);
            // 2. Get already added sector promos
            const promoRes = await http.get(`${BaseUrl}admin/listsectorpromooffers`);
            if (sectorRes.data?.success && promoRes.data?.data) {
                const allSectors = sectorRes.data.data;
                const usedSectors = promoRes.data.data;
                // Get used sector names
                const usedSectorNames = usedSectors.map(item => item.sectorName);
                // FILTER (remove used sectors completely)
                const filtered = allSectors.filter(
                    item => !usedSectorNames.includes(item.MasterValue)
                );
                // Format
                const formatted = filtered.map((item) => ({
                    name: item.MasterValue,
                    value: item.MasterId,
                }));
                setSectorOptions(formatted);
            }
        } catch (err) {
            console.error("Failed to fetch sectors", err);
        } finally {
            setIsSectorLoading(false);
        }
    };

    // GET SECTOR NAME
    const getSectorName = (sectorId) => {
        const sector = sectorOptions.find(
            (s) => String(s.value) === String(sectorId)
        );
        return sector ? sector.name : "-";
    };

    useEffect(() => {
        fetchSectors();
    }, []);

    return (
        <section className="dashboard-block">
            {alertPopup && (
                <div
                    className="custom-alert-pop common_alert_popup"
                    style={{ display: "block" }}
                >
                    <div className="custom-alert-container">
                        <div className="custom-alert-wrap">
                            <div className="custom-alert-header">
                                <h4>Alert</h4>
                            </div>
                            <div className="custom-alert-body">
                                <p>{popupMessage}</p>

                                <div className="alert-buttons">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setAlertPopup(false);
                                            // ONLY redirect for success popup
                                            if (isSuccessPopup) {
                                                window.location.href = "/promooffers?tab=sector";
                                            }
                                        }}
                                        className="popup-alert-btn button"
                                    >
                                        OK
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Sidebar />

            <div className="dash-left">
                <Header />
                <section className="cart-block">
                    <div className="container">
                        <h1 className="checkout-title">Add New Sector Based Promo Offer</h1>

                        <div className="right-table-outer-wrap">
                            {isLoading ? (
                                <div className="loading-buffer"></div>
                            ) : (
                                <form
                                    method="post"
                                    className="addform editform promo-form "
                                    onSubmit={submitButton}
                                >
                                    <div className="input-field col-1">
                                        <span className="labeltxt">{t("cus_sector_txt")}</span>
                                        <select
                                            value={alertSector}
                                            onChange={eventSectorHandleChange}
                                        >
                                            <option value="">{t("select_sector_txt")}</option>
                                            {sectorOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errormsg.sectorErr && <div className="error-msg">{errormsg.sectorErr}</div>}
                                    </div>
                                    {/* <div className="input-field col-1">
                                        <label>Cart Value From</label>
                                        <input
                                            type="text"
                                            value={cartAmountFrom}
                                            onChange={eventFromAmountHandleChange}
                                            name="cartAmountFrom"
                                            className="form-control"
                                            placeholder="Cart amount from"
                                        />
                                        {errormsg.cartAmountFromerr && (
                                            <div className="error-msg">
                                                {errormsg.cartAmountFromerr}
                                            </div>
                                        )}
                                    </div>
                                    <div className="input-field col-1">
                                        <label>Cart Value To</label>
                                        <input
                                            type="text"
                                            value={cartAmountTo}
                                            onChange={eventToAmountHandleChange}
                                            name="cartAmountTo"
                                            className="form-control"
                                            placeholder="Cart amount to"
                                        />
                                        {errormsg.cartAmountToerr && (
                                            <div className="error-msg">
                                                {errormsg.cartAmountToerr}
                                            </div>
                                        )}
                                    </div> */}

                                    <div className="input-field col-1">
                                        <label>Target Cart Value</label>
                                        <input
                                            type="text"
                                            value={cartAmountTarget}
                                            onChange={targetAmountHandleChange}
                                            name="cartAmountTarget"
                                            className="form-control"
                                            placeholder="Cart amount target"
                                        />
                                        {errormsg.cartAmountTargetErr && (
                                            <div className="error-msg">
                                                {errormsg.cartAmountTargetErr}
                                            </div>
                                        )}
                                    </div>

                                    <div className="input-field">
                                    <span className="labeltxt">Flex Title</span>
                                    <input
                                        type="text"
                                        name="flexTitle"
                                        className="form-control"
                                        value={flexTitle}
                                        onChange={flexTitleHandleChange}
                                        placeholder="Enter flex title"
                                    />
                                    {errormsg.flexTitleErr && (
                                        <div className="error-msg">
                                            {errormsg.flexTitleErr}
                                        </div>
                                    )}
                                    </div>
                                    <div className="input-field">
                                        <span className="labeltxt">Notification before reaching the target amount</span>
                                        <textarea
                                            name="alertMessage"
                                            className="form-control"
                                            value={alertMessage}
                                            onChange={messageHandleChange}
                                        />
                                        {errormsg.messageErr && (
                                            <div className="error-msg">
                                                {errormsg.messageErr}
                                            </div>
                                        )}
                                    </div>
                                    <div className="input-field">
                                        <span className="labeltxt">Tooltip before reaching target</span>
                                        <textarea
                                            name="beforeTooltipMessage"
                                            className="form-control"
                                            value={beforeTooltipMessage}
                                            onChange={beforeTooltipHandleChange}
                                        />
                                        {errormsg.beforeTooltipErr && (
                                            <div className="error-msg">
                                                {errormsg.beforeTooltipErr}
                                            </div>
                                        )}
                                    </div>
                                    <div className="input-field">
                                        <span className="labeltxt">Notification after achieving the target amount</span>
                                        <textarea
                                            name="alertMessage1"
                                            className="form-control"
                                            value={alertMessage1}
                                            onChange={message1HandleChange}
                                        />
                                        {errormsg.message1Err && (
                                            <div className="error-msg">
                                                {errormsg.message1Err}
                                            </div>
                                        )}
                                    </div>
                                    <div className="input-field">
                                        <span className="labeltxt">Tooltip after reaching target</span>
                                        <textarea
                                            name="afterTooltipMessage"
                                            className="form-control"
                                            value={afterTooltipMessage}
                                            onChange={afterTooltipHandleChange}
                                        />
                                        {errormsg.afterTooltipErr && (
                                            <div className="error-msg">
                                                {errormsg.afterTooltipErr}
                                            </div>
                                        )}
                                    </div>
                                    {!loading && (
                                        <div className="accordion-box input-field">
                                            <div
                                                onClick={handleclick}
                                                className={
                                                    expanded === true
                                                        ? "accordion-header show"
                                                        : "accordion-header"
                                                }
                                            >
                                                <h2>Free Products</h2>
                                                <span className="show-accordion"></span>
                                            </div>
                                            <div
                                                className="accordion-body"
                                                style={{
                                                    display: expanded === true ? "block" : "none",
                                                }}
                                            >
                                                {!freeloading && (
                                                    <div className="custom_check-box">
                                                        <div className="edit-free-cat-disp">
                                                            <h4>
                                                                Please Select the Categories to display Free
                                                                products
                                                            </h4>
                                                            <div className="edit-free-cat-chks">
                                                                <div className="check-box">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="fcat01"
                                                                        name="pizza"
                                                                        onChange={handleFreeCategoryChange}
                                                                    />
                                                                    <label for="fcat01">Pizza</label>
                                                                </div>
                                                                <div className="check-box">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="fcat02"
                                                                        name="pasta"
                                                                        onChange={handleFreeCategoryChange}
                                                                    />
                                                                    <label for="fcat02">
                                                                        Pasta, Rice & Noodle Sauses
                                                                    </label>
                                                                </div>
                                                                <div className="check-box">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="fcat03"
                                                                        name="burrito"
                                                                        onChange={handleFreeCategoryChange}
                                                                    />
                                                                    <label for="fcat03">Burrito</label>
                                                                </div>
                                                                <div className="check-box">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="fcat04"
                                                                        name="desserts"
                                                                        onChange={handleFreeCategoryChange}
                                                                    />
                                                                    <label for="fcat04">Desserts</label>
                                                                </div>
                                                            </div>
                                                            {filteredFreeProducts.map(
                                                                (prd, index) =>
                                                                    !checkedval.includes(prd.productNumber) && (
                                                                        <div className="check-box">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`freechkbox${index}`}
                                                                                name="freeprd_chkbox"
                                                                                value={prd.productNumber}
                                                                                checked={checkedfreeState[index]}
                                                                                onChange={(e) =>
                                                                                    handleOnChange1(index, e)
                                                                                }
                                                                                disabled={prd.PDP_Status === 'deactivate'}
                                                                            />
                                                                            <label htmlFor={`freechkbox${index}`}>
                                                                                {prd.productDescription}{" "}
                                                                                {"(" + prd.productNumber + ")"}
                                                                            </label>
                                                                        </div>
                                                                    )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {errormsg.checkedfreevalErr && (
                                                <div className="error-msg">
                                                    {errormsg.checkedfreevalErr}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <br />
                                    <div className="input-field">
                                        <label>Free Products Count </label>
                                        <input
                                            type="text"
                                            value={freeProductsCount}
                                            name="freeProductsCount"
                                            onChange={freeCountChange}
                                            className="form-control"
                                            placeholder="Free Products Count"
                                        />
                                        <div style={{ color: "red" }}>
                                            {errmessage.freeProductsCountErr}
                                        </div>
                                    </div>

                                    <div className="input-field">
                                        <label>Price Bands to be excluded from this offer</label>
                                        <br />  <br />
                                        {priceBandIds.map(
                                            (priceBand, index) =>
                                                <div className="check-box" style={{ display: "inline-block", width: "200px" }}>
                                                    <input
                                                        type="checkbox"
                                                        name="PriceBandTobeExcluded"
                                                        id={`PriceBandTobeExcluded${index}`}
                                                        value={priceBand.accountPriceListId}
                                                        onChange={(e) => handleOnChangeBand(index, e)}
                                                        checked={checkedBandState[index]}
                                                    />
                                                    <label htmlFor={`PriceBandTobeExcluded${index}`}>
                                                        {priceBand.accountPriceListId}{" "}
                                                    </label>
                                                </div>

                                        )}
                                    </div>
                                    <br />  <br />

                                    {/* Status Dropdown */}
                                    <div className="input-field">
                                        <label className="full-width">Status</label>
                                        <select
                                            className="col-4"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                    <button type="submit">Submit</button> &nbsp;&nbsp;
                                    <button onClick={(e) => cancelbtn(e)}>Cancel</button>
                                </form>
                            )}
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </section>
    );

};
export default AddSectorPromoOffers;